import { IconLibrary } from './library.js';
const cache = new Map();
const parser = new DOMParser();
// TODO: Cache download response (iconFile) instead of promise.
export const downloadIcon = (url) => {
    url = url.split('#')[0];
    if (cache.has(url)) {
        return cache.get(url);
    }
    const download = fetch(url).then(async (response) => {
        const iconFile = {
            ok: response.ok,
            status: response.status,
            svg: null,
        };
        if (response.ok) {
            const div = document.createElement('div');
            div.innerHTML = await response.text();
            const svg = div.firstElementChild;
            if (svg && svg.tagName.toLowerCase() === 'svg') {
                iconFile.svg = svg.outerHTML;
            }
        }
        return iconFile;
    });
    cache.set(url, download);
    return download;
};
export class GetIconError extends Error {
    constructor(message, status) {
        super(message);
        this.name = 'GetIconError';
        this.stack = new Error().stack;
        this.status = status;
    }
}
/**
 * Downloads and mutates an icon, throws GetIconError if there is an error
 *
 * used by Icon component and as a utility for things like this
 *
 * import { getIcon } from '@cigna/cigna_csg_gsg_cipublic-icon/lib/downlaod.js';
 * import { convertToDataURI } from '@cigna/cigna_csg_gsg_cipublic-icon/lib/utils.js';
 *
 * ...
 *
 * try {
 *   const svg = await getIcon('system', 'caret-down');
 *   someSelectElement.style.backgroundImage = `url('${convertToDataURI(svg)}')`;
 * } catch (error) {
 *   console.log(error.message, error.status);
 * }
 *
 * @param setName string icon set name
 * @param iconName string icon name
 * @param src string optional src to fall back to
 * @returns string SVG html or empty string if URL can't be resolved
 */
export const getIcon = async (setName, iconName, src) => {
    var _a;
    const iconset = IconLibrary.getInstance().getIconset(setName);
    const getUrl = () => (iconset && iconName ? iconset.getIcon(iconName) : src);
    const url = getUrl();
    if (url) {
        try {
            const iconFile = await downloadIcon(url);
            if (url !== getUrl()) {
                // url changed mid fetch, abort
                return '';
            }
            if (iconFile.ok) {
                const doc = parser.parseFromString((_a = iconFile.svg) !== null && _a !== void 0 ? _a : '', 'text/html');
                const svgElement = doc.body.querySelector('svg');
                if (svgElement) {
                    if (iconset) {
                        iconset.mutate(svgElement, iconName);
                    }
                    svgElement.setAttribute('aria-hidden', 'true');
                    return svgElement.outerHTML;
                }
            }
            throw new GetIconError(url, iconFile.status);
        }
        catch {
            throw new GetIconError(url, -1);
        }
    }
    return '';
};
//# sourceMappingURL=download.js.map